<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-badge :value="notificationCount > 0" overlap origin="17px 17px" color="#FF5F5F" class="staff-chat-icon-wrap">
        <template v-slot:badge>
            <span>{{notificationCount}}</span>
        </template>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn small icon @click="toggleStaffChat" v-on="on" class="staff-chat-icon mx-0">
                  <v-icon color="#f7722f" size="16">mdi-account-group</v-icon>
                </v-btn>
            </template>
            <span>{{$t('supporterChat')}}</span>
            <!--<span>Supporter chat ( alt + z )</span>-->
        </v-tooltip>
    </v-badge>
</template>
<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "ToggleStaffChat",
    computed: {
        ...mapState(['notificationCount'])
    },

    methods: {
        ...mapMutations('sideBox', ['toggleStaffChat']),
    }
}
</script>
<style scoped>
    .staff-chat {
        padding: 10px;
        border-radius: 100%;
        width: 60px;
        height: 60px;
    }
</style>
